"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SplitProvider_1 = require("./SplitProvider");
exports.SplitClient = function (_a) {
    var splitKey = _a.splitKey, trafficType = _a.trafficType, children = _a.children;
    var _b = react_1.useContext(SplitProvider_1.SplitContext), factory = _b.factory, isReady = _b.isReady, lastUpdate = _b.lastUpdate, parentClient = _b.client;
    var _c = react_1.useState(parentClient), client = _c[0], setClient = _c[1];
    // create client for splitKey and trafficType
    react_1.useEffect(function () {
        var nextClient = factory ? factory.client(splitKey, trafficType) : null;
        setClient(nextClient);
    }, [factory, splitKey, trafficType]);
    // memoize child context to prevent unnecessary re-renders with object's identity changing
    var context = react_1.useMemo(function () { return ({
        client: client,
        factory: factory,
        isReady: isReady,
        lastUpdate: lastUpdate,
    }); }, [factory, client, isReady, lastUpdate]);
    return (react_1.default.createElement(SplitProvider_1.SplitContext.Provider, { value: context }, children));
};
//# sourceMappingURL=SplitClient.js.map